
import { PropTypes } from 'prop-types';
import { useState } from 'react';
import ModelButton from '../modelBtn/modelButton';
import PopUp from './happening/popUp';
const Happening = ({ happening }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        happening?.children ?
            <>
                <div
                    onClick={
                        () => (modalOpen ? closed() : open())
                    }
                    className="flex shrink-0 flex-col justify-between  gap-5 p-8 border shadow-md rounded-lg  w-[21rem] h-[24.15rem] cursor-pointer">
                    <div className="flex flex-col  gap-5">
                        <h3 className="w-auto text-[#337AB7] text-[1.13rem] font-bold  ">published on {happening.date}</h3>
                        <h3 className="w-auto text-zinc-950 text-xl font-bold  uppercase">{happening.title}</h3>
                    </div>
                    <div className="grid place-items-start gap-5 py-4 border-t-2 border-t-[#C4C4C4]">
                        <p className="w-auto  text-justify   text-base font-medium ">{happening.description}</p>
                    </div>
                </div>
                <ModelButton modalOpen={modalOpen} close={closed}>
                    <PopUp title={happening.title} date={happening.date} description={happening.children} />
                </ModelButton>
            </>
            :
            <div className="flex shrink-0 flex-col justify-between  gap-5 p-8 border shadow-md rounded-lg  w-[21rem] h-[24.15rem]">
                <div className="flex flex-col  gap-5">
                    <h3 className="w-auto text-[#337AB7] text-[1.13rem] font-bold  ">published on {happening.date}</h3>
                    <h3 className="w-auto text-zinc-950 text-xl font-bold  uppercase">{happening.title}</h3>
                </div>
                <div className="grid place-items-start gap-5 py-4 border-t-2 border-t-[#C4C4C4]">
                    <p className="w-auto  text-justify   text-base font-medium ">{happening.description}</p>
                </div>
            </div>
    )
}
Happening.propTypes = {
    happening: PropTypes.object,
}
export default Happening